import UnAuthenticatedLayout from "@/views/Layouts/UnAuthenticated/UnAuthenticatedLayout.vue";
import BaseLayout from "@/views/Layouts/Authenticated/BaseLayout.vue";
import ContentLayout from "@/views/Layouts/Authenticated/Content.vue";

// import modules routes
import defaultModuleRoutes from "./defaultModuleRoutes";
import adminModuleRoutes from "./adminModuleRoutes";
import dashboardModuleRoutes from "./dashboardModuleRoutes";
import resellerModuleRoutes from "./resellerModuleRoutes";
import filesExplorerModuleRoutes from "./filesExplorerModuleRoutes";
import inventoryModuleRoutes from "./inventoryModuleRoutes";
import salesModuleRoutes from "./salesModuleRoutes";
import purchasesModuleRoutes from "./purchasesModuleRoutes";
import crmModuleRoutes from "./crmModuleRoutes";
import inspectproModuleRoutes from "./inspectproModuleRoutes";
import embedModuleRoutes from "./embedModuleRoutes";
import vehiclesModuleRoutes from "./vehiclesModuleRoutes";
import AuthCallback from "@/views/Pages/UnAuthenticated/AuthCallback.vue";

//import middleware
import guest from "@/middleware/guest";

// UnAuthenticatedPages
const NotFound = () => import("@/views/Pages/UnAuthenticated/NotFoundPage.vue");
const Login = () => import("@/views/Pages/UnAuthenticated/Login.vue");
const Links = () => import("@/views/Pages/UnAuthenticated/Links.vue");
const PasswordReset = () =>
  import("@/views/Pages/UnAuthenticated/Password/Reset.vue");
const PasswordEmail = () =>
  import("@/views/Pages/UnAuthenticated/Password/Email.vue");

let unauthenticatedPages = {
  path: "/",
  component: UnAuthenticatedLayout,
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { middleware: guest },
    },
    {
      path: "/auth/callback",
      name: "AuthCallback",
      component: AuthCallback,
      meta: { middleware: guest },
    },
    {
      path: "/links",
      name: "Links",
      component: Links,
    },
    {
      path: "/password/reset",
      name: "PasswordReset",
      component: PasswordReset,
      meta: { middleware: guest },
    },
    {
      path: "/password/email",
      name: "PasswordEmail",
      component: PasswordEmail,
      meta: { middleware: guest },
    },
  ],
};

const routes = [
  /** base routes */
  {
    path: "/",
    redirect: "/dashboard",
  },
  unauthenticatedPages,
  {
    path: "/not-found",
    component: NotFound,
  },
  {
    path: "/",
    component: BaseLayout,
    children: defaultModuleRoutes,
  },
  {
    path: "/",
    component: BaseLayout,
    children: dashboardModuleRoutes,
  },
  {
    path: "/files",
    component: BaseLayout,
    children: filesExplorerModuleRoutes,
  },
  {
    path: "/inventory",
    component: BaseLayout,
    children: inventoryModuleRoutes,
  },
  {
    path: "/crm",
    component: BaseLayout,
    children: crmModuleRoutes,
  },
  {
    path: "/sales",
    component: BaseLayout,
    children: salesModuleRoutes,
  },
  {
    path: "/purchases",
    component: BaseLayout,
    children: purchasesModuleRoutes,
  },
  {
    path: "/reseller",
    component: BaseLayout,
    children: resellerModuleRoutes,
  },
  {
    path: "/inspecpro",
    component: BaseLayout,
    children: inspectproModuleRoutes,
  },
  {
    path: "/vehicles",
    component: BaseLayout,
    children: vehiclesModuleRoutes,
  },
  {
    path: "/admin",
    component: BaseLayout,
    children: adminModuleRoutes,
  },
  {
    path: "/embed",
    component: ContentLayout,
    children: embedModuleRoutes,
  },
  {
    path: "**",
    redirect: "/not-found",
  },
];

export default routes;
